import 'css-chunksrc/client/scenes/task/styles.scss';export default {
  "task": "_task_19itq_1",
  "taskLoading": "_taskLoading_19itq_10",
  "loader": "_loader_19itq_16",
  "loaderMain": "_loaderMain_19itq_30",
  "main": "_main_19itq_37",
  "content": "_content_19itq_43",
  "secondaryCriteria": "_secondaryCriteria_19itq_49",
  "label": "_label_19itq_54",
  "row": "_row_19itq_60",
  "configurationIconBox": "_configurationIconBox_19itq_71",
  "configurationIcon": "_configurationIcon_19itq_71",
  "scrollWrapper": "_scrollWrapper_19itq_89",
  "timeline": "_timeline_19itq_98",
  "timestamp": "_timestamp_19itq_105",
  "comments": "_comments_19itq_116",
  "hierarchy": "_hierarchy_19itq_124",
  "subTitle": "_subTitle_19itq_128",
  "list": "_list_19itq_133",
  "contentWrapper": "_contentWrapper_19itq_140",
  "constraints": "_constraints_19itq_148",
  "constraintsText": "_constraintsText_19itq_156",
  "icon": "_icon_19itq_162",
  "group": "_group_19itq_168",
  "wrapper": "_wrapper_19itq_171",
  "header": "_header_19itq_192",
  "contentHeader": "_contentHeader_19itq_205",
  "title": "_title_19itq_214",
  "rightContent": "_rightContent_19itq_222",
  "rightContentMultiProject": "_rightContentMultiProject_19itq_228",
  "iconBox": "_iconBox_19itq_232",
  "modal": "_modal_19itq_242",
  "contentModal": "_contentModal_19itq_252",
  "contentProjectRedirection": "_contentProjectRedirection_19itq_257",
  "scenePlaceholder": "_scenePlaceholder_19itq_261",
  "folderIcon": "_folderIcon_19itq_272"
};